/* globalmodule */
/* homemodule */
define('../src/sublayouts/m12-masthead/m12-masthead',[
        'jquery',
        'breakpoint',
        'tooltipster',
        'lib/utils',
        '!components/m12-masthead/m12-masthead-mobile-menu',
        '!components/m12-masthead/m12-masthead-desktop-menu'
    ],

    function($, breakpoint, tooltipster, utils, MobileMenu, DesktopMenu) {

        'use strict';

        /**
         * Masthead component.
         * @exports Masthead
         * @constructor
         */

        var Masthead = function($component) {

            this.$component = $component;

            return this;
        };

        Masthead.prototype.init = function() {
            var fontsize = this.getCookie("fontsize");
            var body = $('body');
            var _this = this;

            if (document.body.style.fontSize == "") {
                document.body.style.fontSize = "1em";
            }

            if (fontsize != "" && fontsize > 0) {
                //this.increaseFontSize(fontsize);
            }

            this.$anchor = this.$component.find('[data-m13-back-to-top="true"]');
            this.$anchor.on('click', $.proxy(this.toTop, this));

            // cache dom elements
            this.$headerMain = this.$component.find('[ data-m12-main ]');
            this.$headerBar = this.$component.find('[ data-m12-bar ]');
            this.$breadcrumbs = this.$component.find('[ data-m12-breadcrumbs ]');

            // general props
            if (this.$headerBar.length) {
                this.headerBarTop = this.$headerBar.offset().top;
            };
            this.fixedHeader = false;
            this.labels = this.$component.data('labels');
            this.fontSize = $('.m12-bar__breadcrumb--tools__fontSizeRange');

            // class name and data attr props
            this.headerMainOffscreenClassname = 'm12-main--offscreen';
            this.headerBarFixedClassname = 'm12-bar--fixed';
            this.headerBarFixedNewClassname = 'm12-bar--fixed-new';
            this.headerBarFixedDataAttr = 'data-m12-bar-fixed';
            this.breadcrumbsFixedClassname = 'm12-bar__breadcrumbs--fixed';
            this.breadcrumbsFixedToggleClassname = 'm12-bar__breadcrumbs--toggle';
            this.breadcrumbsFixedNewClassname = 'm12-bar__breadcrumbs--fixed-new';

            // init methods
            this.tooltip();
            this.menuOver();
            this.respond();
            this.watchHeaderBar();
            this.fontSlide();
            if ($('.activate-idlewatch').length > 0) {
                _this.idleWatcher(parseInt($('.activate-idlewatch').attr('data-timer')));
            };

            $(window).off('reinit_tooltip').on('reinit_tooltip', function() {
                _this.tooltip();
            });

            // watch for events
            $(breakpoint).on('change', $.proxy(this.respond, this));
            $(window).on('initMobile', function() {
                _this.respond();
            });
            $(window).scroll($.proxy(this.watchHeaderBar, this));
            $(window).on('orientationchange', $.proxy(this.orientationchange, this));

            $('.m12-myaccount__login-form').find('button').on("DOMSubtreeModified", function() {
                $('.create').addClass('create--active');
            });

            $('.m12-myaccount__login-form').find('button').on("propertychange", function() {
                $('.create').addClass('create--active');
            });


            var wHeight = $(window).height() + 130,
                docHeight = $(document).height();
            if (wHeight > docHeight) {
                this.$breadcrumbs.addClass(this.breadcrumbsFixedClassname);
                this.$breadcrumbs.addClass(this.breadcrumbsFixedToggleClassname);
            }

            if (utils.breakpoint() === 's' || utils.breakpoint() === 'm') {
                this.$breadcrumbs.addClass(this.breadcrumbsFixedClassname);
            }


            // popup modal switch language 
            //$('.m12-tools__link--lang').on('click', function (event) {
            //      var defRef = $(this).attr('href');

            //      event.preventDefault();
            //      $('.mobile-menu-closebtn').trigger('click');
            //      $('.m39-modal__triggerLang').trigger('click');
            //      $('.m39-m12-yes').attr('href', defRef)
            //  })

            $('.skip-content a').click(function(e) {
                e.preventDefault();
                
                $('html, body').animate({
                    scrollTop: $('#rs_area').offset().top + 110 - _this.$component.height()
                }, 'slow');


                setTimeout(function() {
                    window.location.href = window.location.href.replace('#rs_area', '') + '#rs_area'
                }, 601);
            });

            this.$component.css('height', this.$component.find('.m12-main').outerHeight(true) + this.$component.find('.m12-bar').outerHeight(true));

            //$('#rs_area').focus();

            $('.m60-grid__scroll').css('width', ($('.m60-teaser').length * 250).toString() + 'px');

            $('.m12-lang-switch_mobile').find('a').attr('href', $('.m12-tools__link-lang').attr('href'));

            this.$component.find('.m12-myaccount__loggedin').off('click.myaccount').on('click.myaccount', function(event) {
                event.preventDefault();
                $(this).closest('.m12-myaccount__item').find('.m12-myaccount--dropdown').toggleClass('active');
                $('body').toggleClass('loggedin_active');
                _this.$component.toggleClass('loggedin_active');
            });

            this.$component.find('.m12-myaccount--dropdown_closebtn').off('click.myaccount').on('click.myaccount', function(event) {
                $(this).closest('.m12-myaccount__item').find('.m12-myaccount--dropdown').removeClass('active');
                $('body').removeClass('loggedin_active');
                _this.$component.removeClass('loggedin_active');
            });

            $(document).off('click.myaccount').on('click.myaccount', function(event) {
                if ($(event.target).closest('.m12-myaccount__item').length == 0) {
                    $('.m12-myaccount--dropdown.active').removeClass('active');
                    $('body').removeClass('loggedin_active');
                };
            });

        };

        Masthead.prototype.tooltip = function() {
            var _this = this,
                $img = $('img').not('.tooltip'),
                warning = '';

            if (utils.isRTL()) {
                warning = 'يفتح في نافذة جديدة'
            } else {
                warning = 'Opens in a new window'
            }

            $img.each(function() {
                var text = $(this).attr('alt');

                $(this).tooltipster({
                    content: text,
                    maxWidth: 250,
                    arrow: true
                });
            });

            $('a').each(function() {
                if ($(this).attr('target') == '_blank') {
                    $(this).tooltipster({
                        content: warning,
                        maxWidth: 250,
                        side: 'right',
                        arrow: true
                    });
                    if ($(this).find('.aria-only').length == 0) {
                        $(this).append('<span class="aria-only">' + warning + '</span>');
                    }
                }
            });

        };

        Masthead.prototype.menuOver = function() {
            var _this = this;

            $('.m12-menu_expandable').not('.m12-menu_expandable--mobile').on('click', function() {
                $('.m12-menuover').removeClass('hidden');
                $(this).toggleClass('active');
                setTimeout(function() {
                    $('.m12-menuover').addClass('m12-menuover--active');
                    $('body').addClass('unscrollable');
                }, 100);
            });

            $('.m12-menuover-closebutton').on('click', function() {
                $('.m12-menuover').removeClass('m12-menuover--active');
                $('body').removeClass('unscrollable');
                setTimeout(function() {
                    $('.m12-menuover').addClass('hidden');
                }, 1100);
            });

            $(document).on('keydown', function(event) {
                if (event.key === 'Escape' && $('.m12-menuover').hasClass('m12-menuover--active')) {
                    $('.m12-menuover').removeClass('m12-menuover--active');
                    $('body').removeClass('unscrollable');
                    setTimeout(function() {
                        $('.m12-menuover').addClass('hidden');
                    }, 1100);
                }
            });

            $('.m12-menuover-main_item').on('click', function() {
                var call = $(this).attr('data-call'),
                    href = $(this).attr('data-loginhref');

                if ($(window).width() > 1024) {
                    $('.m12-menuover-main_item').each(function() {
                        $(this).removeClass('m12-menuover-main_itemactive');
                    });
                    $(this).addClass('m12-menuover-main_itemactive');
                }

                $('.m12-menuover-primary').each(function() {
                    $(this).removeClass('m12-menuover-primaryactive');
                });

                $('.m12-menuover-secondary').each(function() {
                    $(this).removeClass('m12-menuover-secondaryactive');
                });
                if ($(window).width() > 1024) {
                    $('.m12-menuover-primary').each(function() {
                        var tag = $(this).attr('data-tag');

                        if (tag == call) {
                            $(this).addClass('m12-menuover-primaryactive');
                            $(this).find('.m12-menuover-primary_item:first-child').click();
                            $(this).find('.m12-menuover-primary_item:first-child').focus();
                        }
                    });
                };

                if (href != "" && href != undefined) {
                    $('.m12-menuover-footer').find('.button[data-login="true"]').attr('href', href);
                }

            });

            $('.m12-menuover-primary_item').on('click', function() {
                var call = $(this).attr('data-call');

                if ($(window).width() > 1024) {
                    $('.m12-menuover-primary_item').each(function() {
                        $(this).removeClass('m12-menuover-primary_itemactive');
                    });
                    $(this).addClass('m12-menuover-primary_itemactive');
                }

                $('.m12-menuover-secondary').each(function() {
                    $(this).removeClass('m12-menuover-secondaryactive');
                });

                $('.m12-menuover-secondary').each(function() {
                    var tag = $(this).attr('data-tag');

                    if (tag == call) {
                        $(this).addClass('m12-menuover-secondaryactive');
                        $(this).find('.m12-menuover-secondary_item:first-child').find('a').focus();
                    }
                });
            });


            $('.button--menu').on('click', function() {
                var call = $(this).attr('data-call');

                $('.m12-menuover-main_item').each(function() {
                    var tag = $(this).attr('data-call');

                    if (tag == call) {
                        $('.m12-menu_expandable').click();
                        $(this).click();
                    };
                });
            });

            $('.m12-menuover-footer').find('.m31-search__button').off('click.search').on('click.search', function() {
                $('.m12-menuover-closebutton').click();
                setTimeout(function() {
                    $('.m12-tools').find('.m31-search--expand').click();
                    $('.m12-tools').find('.m31-search--input').focus()
                }, 50)
            });
        };

        Masthead.prototype.respond = function() {

            // trigger mobile view for 's' and 'm' breakpoints

            if (utils.breakpoint() === 's' || utils.breakpoint() === 'm') {

                MobileMenu.init(this.$component);

            } else {

                DesktopMenu.init(this.$component);
            }
        };
        var lastScrollTop = 0

        Masthead.prototype.idleWatcher = function(timer_value) {
            var _this = this,
                t;

            // DOM Events
            $(window).on('mousemove', function() {
                resetTimer(timer_value * 60000);
            });
            $(window).on('keypress', function() {
                resetTimer(timer_value * 60000);
            });

            function logout() {
                $(window).on('mousemove', function() {
                    window.location.reload();
                });
                $(window).on('keypress', function() {
                    window.location.reload();
                });
            }

            function resetTimer(value) {
                clearTimeout(t);
                t = setTimeout(logout, value)
                // 1000 milisec = 1 sec
            }

            window.onload = resetTimer(timer_value * 60000);
        };

        Masthead.prototype.watchHeaderBar = function() {

            var st = $(window).scrollTop()
            var poss = 0

            var wHeight = $(window).height() + 130,
                docHeight = $(document).height();


            if (Math.abs(lastScrollTop - st) <= poss)
                return;

            if (st > lastScrollTop && st > 0 && $('.mobile-menu--active').length == 0) {
                $('.m71-cookie').trigger('posm71check');
                $('.new-notification').trigger('posm20check');
                $(window).trigger('overrideFixed');
                this.$headerBar.removeClass(this.headerBarFixedClassname);
                $('.m13-footer--floating').addClass('scroll');
                this.$headerBar.addClass(this.headerBarFixedNewClassname);
                // $('.m12-bar--investor__wrapper').removeClass('fixed-new');
                // $('.m12-bar--investor__wrapper').addClass('fixed');
                $('.m12-bar--substitute').show();
                // this.$headerMain.removeClass( this.headerMainOffscreenClassname );
                this.$headerBar.attr(this.headerBarFixedDataAttr, false);
                this.$breadcrumbs.addClass(this.breadcrumbsFixedClassname);
                this.fixedHeader = false;
                this.$component.removeClass('m12-masthead--dark');
                    $('.m12-logo img').each(function() {
                        $(this).attr('src', $(this).attr('data-defaultsrc'));
                        $('.m12-bar--logo_mobile img').attr('src', $('.m12-logo-image--dewa').attr('data-defaultsrc'));
                    });
            } else if (st < lastScrollTop) {
                if (st > 0) {
                    $('.m71-cookie').trigger('posm71check');
                    $('.new-notification').trigger('posm20check');
                    $(window).trigger('overrideFixedNew');
                    this.$headerBar.addClass(this.headerBarFixedClassname);
                    $('.m13-footer--floating').removeClass('scroll');
                    this.$headerBar.removeClass(this.headerBarFixedNewClassname);
                    // $('.m12-bar--investor__wrapper').addClass('fixed-new');
                    // $('.m12-bar--investor__wrapper').removeClass('fixed');
                    $('.m12-bar--substitute').show();
                    // this.$headerMain.addClass(this.headerMainOffscreenClassname );
                    this.$headerBar.attr(this.headerBarFixedDataAttr, true);
                    this.$breadcrumbs.addClass(this.breadcrumbsFixedClassname);
                    this.fixedHeader = true;
                    this.$component.removeClass('m12-masthead--dark');
                    $('.m12-logo img').each(function() {
                        $(this).attr('src', $(this).attr('data-defaultsrc'));
                        $('.m12-bar--logo_mobile img').attr('src', $('.m12-logo-image--dewa').attr('data-defaultsrc'));
                    });
                } else {
                    $('.m71-cookie').trigger('negm71check');
                    $('.new-notification').trigger('negm20check');
                    $(window).trigger('overrideFixedRemove');
                    this.$headerBar.removeClass(this.headerBarFixedClassname);
                    $('.m13-footer--floating').removeClass('scroll');
                    this.$headerBar.removeClass(this.headerBarFixedNewClassname);
                    // $('.m12-bar--investor__wrapper').removeClass('fixed-new');
                    // $('.m12-bar--investor__wrapper').removeClass('fixed');
                    $('.m12-bar--substitute').hide();
                    // this.$headerMain.removeClass( this.headerMainOffscreenClassname );
                    this.$headerBar.attr(this.headerBarFixedDataAttr, false);
                    this.fixedHeader = false;
                    if ($('[data-component="m1-hero"]').length != 0 && ($('m1-hero--stock').length == 0 && $('m1-hero--variant').length == 0)) {
                        this.$component.addClass('m12-masthead--dark');
                        $('.m12-logo img').each(function() {
                            $(this).attr('src', $(this).attr('data-hompagesrc'))
                        });
                        $('.m12-bar--logo_mobile img').attr('src', $('.m12-logo-image--dewa').attr('data-hompagesrc'));
                    }
                    if (wHeight < docHeight) {
                        this.$breadcrumbs.removeClass(this.breadcrumbsFixedClassname);
                        this.$breadcrumbs.removeClass(this.breadcrumbsFixedToggleClassname)
                    }
                    if (utils.breakpoint() === 's' || utils.breakpoint() === 'm') {
                        this.$breadcrumbs.addClass(this.breadcrumbsFixedClassname);
                    }
                }
            };

            if (st + wHeight >= docHeight) {
                $('.m13-footer--floating').removeClass('scroll');
            };

            lastScrollTop = st;
        };

        Masthead.prototype.orientationchange = function() {
            this.respond();
        };

        Masthead.prototype.fontSlide = function() {
            var _this = this,
                width = 1000,
                width_classes = ['grid', 'm13-supplementary__wrapper', 'm12-main', 'm12-bar__wrapper', 'm12-bar__breadcrumbs-wrapper', 'm12-subsection__wrapper', 'service-message__wrapper', 'm12-main__navs--inner'];

            $(_this.fontSize).attr('min', '-0.5');
            $(_this.fontSize).attr('max', '0.5');
            $(_this.fontSize).attr('step', '0.125');
            $(_this.fontSize).on('change', function() {
                document.body.style.fontSize = "1em";
                document.body.style.fontSize = parseFloat(document.body.style.fontSize) + ($(this).val() * 0.5) + "em";
                for (var e in width_classes) {
                    $(e).css('width', width + ($(this).val() * 500));
                };
                console.log($(this).val())
                _this.setCookie("fontsize", ($(this).val()), 1);
            })
            $(_this.fontSize).attr('value', '0');
        };

        Masthead.prototype.setCookie = function(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";path=/; " + expires;
        };

        Masthead.prototype.getCookie = function(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        };

        Masthead.prototype.searchActivate = function() {
            var searchButton = $('.m12-search__submit'),
                searchPanel = $('.m12-search__panel');

            searchButton.on('click', function() {
                searchPanel.addClass('m12-search__panel--active')
            });
        }

        Masthead.prototype.toTop = function(e) {

            e.preventDefault();

            $('body').attr('tabindex', -1);

            if (utils.isWindowsPhone()) {

                $('html, body').scrollTop(0);
            } else {

                $('html, body').animate({

                    scrollTop: 0
                }, 500, function() {

                    $('#page').focus();
                });
            }
        };

        return Masthead;
    });
